import { render, staticRenderFns } from "./PlanTemplate.vue?vue&type=template&id=63efe422"
import script from "./PlanTemplate.ts?vue&type=script&lang=ts&external"
export * from "./PlanTemplate.ts?vue&type=script&lang=ts&external"
import style0 from "./PlanTemplate.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports